import Cookies from 'js-cookie';

export const getCookie = <T = any>(name: string): T | string | undefined => {
  const result = Cookies.get(name);

  try {
    return JSON.parse(result) as T;
  } catch {
    return result;
  }
};

export const setCookie = <T = any>(name: string, value: string | T, options?: Cookies.CookieAttributes): void => {
  value = typeof value === 'string' ? value : JSON.stringify(value);

  Cookies.set(name, value, options);
};

export const removeCookie = (name: string, options?: Cookies.CookieAttributes): void => Cookies.remove(name, options);
